import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = {
    url: String,
    count: Number,
    periodKey: String,
    periodLabel: String
  }

  async markAll() {
    const recordLabel = this.countValue === 1 ? "record" : "records"
    const confirmation = await Swal.fire({
      title: "Mark all as receipted?",
      html: `This will mark <strong>${this.countValue}</strong> ${recordLabel} from ${this.periodLabelValue} as receipted. Continue?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, mark all",
      cancelButtonText: "Cancel",
      reverseButtons: true
    })

    if (!confirmation.isConfirmed) return

    const originalContent = this.element.innerHTML
    this.element.disabled = true
    this.element.textContent = "Marking…"

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        },
        body: new URLSearchParams({ period: this.periodKeyValue })
      })

      const data = await response.json().catch(() => ({}))
      if (!response.ok) throw new Error(data.error || "The records could not be updated.")

      const updatedCount = Number(data.updated_count) || 0
      window.dispatchEvent(new CustomEvent("receipts:marked", {
        detail: { timestamp: data.marked_at_label || "" }
      }))
      this.updateSummaryCounts(updatedCount)
      this.element.classList.add("hidden")

      await Swal.fire({
        title: "Receipting updated",
        text: updatedCount === 1 ?
          "1 record was marked as receipted." :
          `${updatedCount} records were marked as receipted.`,
        icon: "success",
        timer: 1800,
        showConfirmButton: false
      })
    } catch (error) {
      this.element.innerHTML = originalContent
      this.element.disabled = false

      await Swal.fire({
        title: "Unable to update receipting",
        text: error.message,
        icon: "error"
      })
    }
  }

  updateSummaryCounts(updatedCount) {
    const pendingCount = document.getElementById("receipt-needs-count")
    if (pendingCount) pendingCount.textContent = "0"

    const markedCount = document.getElementById("receipt-sent-count")
    if (!markedCount) return

    const currentValue = Number.parseInt(markedCount.textContent.replace(/[^0-9-]/g, ""), 10)
    if (Number.isNaN(currentValue)) return

    markedCount.textContent = new Intl.NumberFormat().format(currentValue + updatedCount)
  }
}
